import ResearchFiltering from 'src/javascripts/components/ResearchFiltering';
import {filterTypeahead} from 'src/javascripts/components/typeaheads/TypeaheadBloodhounds';
import {genericDisplayTemplate, logoTemplate} from 'src/javascripts/components/typeaheads/TypeaheadTemplates';
import Table from 'src/javascripts/components/Table';
import DistributionChart from 'src/javascripts/components/charts/DistributionChart';
import Spinner from 'src/javascripts/components/utilities/Spinner';
import Swal from 'sweetalert2';
import TrendChart from 'src/javascripts/components/charts/TrendChart';

export default function() {
  const accountUrl = $('body').attr('data-account-url');

  // Set rendering params 
  const renderingParams = function(el) {
    let params = {};
    let recordId = el.attr('data-record-id');
    let recordType = el.attr('data-record-type');
    let frameworkId = el.attr('data-framework-id');
    let benchmarkPortfolioIds = el.attr('data-benchmark-portfolio-ids');
    let benchmarkIssuerIds = el.attr('data-benchmark-issuer-ids');
    params['record_id'] = recordId;
    params['record_type'] = recordType;
    if (typeof frameworkId !== 'undefined') {params['framework_id'] = frameworkId}
    if (typeof benchmarkPortfolioIds !== 'undefined') {params['benchmark_portfolio_ids'] = benchmarkPortfolioIds}
    if (typeof benchmarkIssuerIds !== 'undefined') {params['benchmark_issuer_ids'] = benchmarkIssuerIds}

    // Set any additional params based on any filter attributes
    $.each(el.data(), function(key, val) {
      if (key.indexOf('filter') !== -1) {
        let k = key.replace("filters", "")
        k = k.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
        k = k.slice(1);
        params[k] = val
      }
    })

    return params;
  }

  // Render a container
  const renderContainer = function(el, attrs = null) {

    // Spinner
    Spinner(el);

    // Set vars and url
    let key = el.attr('data-key');
    let url = '/' + accountUrl + '/sections/renderings/' + key;

    // Set params
    let params = renderingParams(el);

    // Run ajax call
    $.ajax({
      type: "GET",
      dataType: "script",
      url: url + '.js?' + $.param(params)
    });
    $(document).on("turbo:before-cache", function() { el.empty() })

  }

  // Iterate through rendering containers
  $('.rendering-container').each(function() {

    // Set element
    let el = $(this);

    // Render container
    renderContainer(el);

  })
  
  // Update rendering container
  $('.update-rendering').click(function() {
    let el = $(this).closest('.Card').find('.rendering-container');
    let attr = $(this).attr('data-attr');
    let val = $(this).attr('data-value');

    // Update label
    let label = $(this).closest('.dropdown').find('.left .label');
    let text = $(this).text();
    if (typeof label !== 'undefined') { label.empty().append(text) }

    // Spinner
    Spinner(el);

    // Set vars and url
    let key = el.attr('data-key');
    let url = '/' + accountUrl + '/sections/renderings/' + key;

    // Set params
    let params = renderingParams(el);
    params[attr] = val;

    // Run ajax call
    $.ajax({
      type: "GET",
      dataType: "script",
      url: url + '.js?' + $.param(params)
    });

  })

  // Distribution chart
  let hasDist = $('.distributionChart').length !== 0
  let c3NotLoaded = typeof $('.distributionChart').data('c3-chart') === 'undefined';
  if ((hasDist) && (c3NotLoaded)) {
    $('.distributionChart').each(function() {
      let $el = $(this);
      let $chart = new DistributionChart($el);
      $.when( $chart.getData() )
       .then( data => $chart.render(data) );
    })
  }

  // Trend chart 
  let hasTrend = $('.trendChart').length !== 0
  let c3NotLoadedTrend = typeof $('.trendChart').data('c3-chart') === 'undefined';
  if ((hasTrend) && (c3NotLoadedTrend)) {
    $('.trendChart').each(function() {
      let $el = $(this);
      let $chart = new TrendChart($el);
      $.when( $chart.getData() )
       .then( data => $chart.render(data) );
    })
  }



}